import React, { memo } from "react";

const Hamburger = memo(({ isOpen, onClick }) => (
  <button className={`hamburger ${isOpen ? 'open' : 'close'}`} onClick={onClick}>
    <span className="hamburger-line line-1 bg-black dark:bg-white transition-colors duration-1000" />
    <span className="hamburger-line line-2 bg-black dark:bg-white transition-colors duration-1000" />
    <span className="hamburger-line line-3 bg-black dark:bg-white transition-colors duration-1000" />
  </button>
));

export default Hamburger;
